<template>
  <v-container>
    <h1 class="mb-5">Rekord Butikksystem</h1>

    <v-card v-if="isDemoMode" class="mb-5 red lighten-4">
      <v-banner icon="mdi-information-variant" color="indigo lighten-5">
        Velkommen til Rekord demo! Her kan du se markedsplasser og butikker som
        er tilgjengelig i systemet. En markedsplass er en samling av butikker
        som bl.a kan brukes av Reko-Ringer, markeder, og f.eks butikker i
        sentrumskjernen.
        <br /><br />
        Merk at butikkene under ligger kun tilgjengelig for å demonstrere
        systemet og ikke er faktiske butikker du kan handle fra nå.
      </v-banner>
    </v-card>

    <v-card class="lighten-5 deep-purple mb-10" elevation="3">
      <v-card-title class="white--text deep-purple">
        <v-icon color="white" class="pr-2">mdi-shopping</v-icon>
        Markedsplasser
      </v-card-title>
      <MarketplaceList />
    </v-card>

    <v-card class="lighten-5 orange" elevation="3">
      <v-card-title class="white--text orange">
        <v-icon color="white" class="pr-2">mdi-store</v-icon>
        Butikker
      </v-card-title>
      <VendorList :vendors="vendors" />
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import MarketplaceList from "@/components/MarketplaceList";
import VendorList from "@/components/VendorList";

export default {
  name: "Home",

  components: {
    MarketplaceList,
    VendorList,
  },

  data() {
    return {
      vendors: [],
    };
  },

  computed: {
    isDemoMode: function () {
      return process.env.VUE_APP_DEMO_MODE == 1;
    },
  },

  async created() {
    this.vendors = await backend.get("vendors/", {
      featured: true,
    });
  },
};
</script>
